'use strict';
import template from './listadoBonoRegularizado.html';
import controller from './listadoBonoRegularizado.controller';

const ListadoMunicipiosComponent = {
  controller,
  template
};

export default ListadoMunicipiosComponent;


// WEBPACK FOOTER //
// ./src/app/components/listados/listadoBonoRegularizado/listadoBonoRegularizado.component.js